import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import defaultPic from './default-pic.png'
import styles from './BlogEntryCard.module.scss'
import { Link } from 'react-router'
import Time from 'react-time'

class BlogEntryCard extends React.Component {
  
  static propTypes() {
    return {
      page: React.PropTypes.object,
    }
  }

  render () {
    const page = this.props.page || {};
    const data = page.data || {};
    const thumb = page.path + data.thumb || defaultPic;
    console.log(data);

    return (
      <Link to={prefixLink(data.path)}>
        <div className={styles.blogEntryCard}>
          <img src={prefixLink(thumb)} />
          <div className={styles.info} >
            <h3>{data.title}</h3>
            <Time value={data.date} format="YYYY MM DD" />
          </div>
        </div>
      </Link>
    
    )
  }
}

export default BlogEntryCard



/** WEBPACK FOOTER **
 ** ../components/BlogEntryCard.js
 **/